import { IDirector } from 'pared/data/getDirectors'

import useLocationDiscounts from './useLocationDiscounts'
import useLocationGroupDiscounts from './useLocationGroupDiscounts'

export interface IHeatMapCell {
  value: number
  color: string
}

export interface IDiscountType {
  storeId: number
  store: string
  directorId: number
  directorName: string
  totalDiscounts: [string, IHeatMapCell, string]
  grossSales: string
}

function useDiscounts(
  directors: IDirector[],
  isBreakdownByDirectors: boolean,
  selectedDiscount: string[],
  locationIds?: number[],
  locationGroupIds?: number[],
  startDate?: string,
  endDate?: string,
  locationGroupType?: string,
) {
  const { discountLocationData, discountLocationLoading } =
    useLocationDiscounts(
      selectedDiscount,
      locationIds,
      locationGroupIds,
      startDate,
      endDate,
    )
  const { discountLocationGroupData, discountLocationGroupLoading } =
    useLocationGroupDiscounts(
      directors,
      selectedDiscount,
      locationGroupIds,
      startDate,
      endDate,
      locationGroupType,
    )

  return {
    discounts: isBreakdownByDirectors
      ? discountLocationGroupData
      : discountLocationData,
    discountLoading: isBreakdownByDirectors
      ? discountLocationGroupLoading
      : discountLocationLoading,
  }
}

export default useDiscounts
